<template>
  <div class="catalog-skeleton">
    <div class="catalog-skeleton__tabs">
      <v-skeleton-loader
        v-for="i in 4"
        :key="i"
        type="chip"
        class="catalog-skeleton__chip"
        height="48" />
    </div>
    <VariantsSkeletonLoader />
  </div>
</template>

<script>
import VariantsSkeletonLoader from './VariantsSkeletonLoader.vue'

export default {
  name: 'CatalogSkeletonLoader',
  components: { VariantsSkeletonLoader },
}
</script>

<style scoped>
.catalog-skeleton {
  display: flex;
  flex-direction: column;
}

.catalog-skeleton__tabs {
  display: flex;
  background-color: var(--v-primary-base);
  border-radius: 4px;
  padding: 0.5rem;
  gap: 0.25rem;
  overflow: hidden;
}

.catalog-skeleton__chip {
  flex: 1;
  min-width: 5rem;
  border-radius: 4px;
}

.catalog-skeleton__chip::v-deep .v-skeleton-loader__chip {
  background-color: rgba(255, 255, 255, 0.2);
}
</style>
